import gsap from 'gsap'
// var replayButton = document.querySelector('.replay-animation')
//UTILITY FUNCTIONS
function $ (className){
  return document.querySelector(`.${className}`)
}
function $$ (id){
  return document.querySelector(`#${id}`)
}

// blend two hex colors together by an amount
// https://stackoverflow.com/questions/6367010/average-2-hex-colors-together-in-javascript/56348573#56348573
function blendColors(colorA, colorB, amount) {
  const [rA, gA, bA] = colorA.match(/\w\w/g).map((c) => parseInt(c, 16));
  const [rB, gB, bB] = colorB.match(/\w\w/g).map((c) => parseInt(c, 16));
  const r = Math.round(rA + (rB - rA) * amount).toString(16).padStart(2, '0');
  const g = Math.round(gA + (gB - gA) * amount).toString(16).padStart(2, '0');
  const b = Math.round(bA + (bB - bA) * amount).toString(16).padStart(2, '0');
  return '#' + r + g + b;
}

// SELECTIONS
const boResourceTank = $('bo-resource-tank');
const addResourceTank = $('add-resource-tank');
const finalResourceTank = $('final-resource-tank')
const mixer = $('static-inline-mixer')

const spiralR = $('spiral-R')
const spiralL = $('spiral-L')
const flowR = $('flow-R')
const flowL = $('flow-L')
const arrowR = $('arrow-R')
const arrowL = $('arrow-L')

//Pipes
const mixerCover = $('mixer-cover')
const jetMixer = $('jet-mixer')
const boPipeOuter = $('bo-pipe-outer')
const boPipeInner = $('bo-pipe-inner')
const addPipeOuter = $('add-pipe-outer')
const addPipeInner = $('add-pipe-inner')
const mixerOutletPipeOuter = $('mixer-outlet-pipe-outer')
const mixerOutletPipeInner = $('mixer-outlet-pipe-inner')
const reEntryPipeOuter = $('re-entry-pipe-outer')
const reEntryPipeInner = $('re-entry-pipe-inner')

//Valves
const boGateValve = $('bo-gate-valve')
const boGateValve2 = $('bo-gate-valve-2')
const boNRCValve = $('bo-NRC-valve-BL')
const addGateValve = $('add-gate-valve')
const addGateValve2 = $('add-gate-valve-2')
const reEntryValve = $('re-entry-gate-valve')
const reEntryValve2 = $('re-entry-gate-valve-2')

//Flows
const boFlow = $('bo-flow')
const addFlow = $('add-flow')
const staticMixerExitFlow = $('static-mixer-exit-flow')
const reEntryFlow = $('re-entry-flow')

const mixingFlowLines = $('mixing-flow-lines')
const mixingFlowLinesArray = [$('b-1'),$('b-2'),$('b-3'),$('middle-0'),$('t-1'),$('t-2'),$('t-3')]
const linearGradientLinesArray = [
  $$('paint3_linear').firstChild,
  $$('paint4_linear').firstChild,
  $$('paint5_linear').firstChild,
  $$('paint6_linear').firstChild,
  $$('paint7_linear').firstChild,
  $$('paint8_linear').firstChild,
  $$('paint9_linear').firstChild,
]
//Fan
const boPump = $('bo-pump')
const addPump = $('add-pump')

//TEXTS
const baseOil = $('base-oil')
const additive = $('additive')
const mixriteStaticMixer = $('mixrite-static-mixer')

//Tank
const linearGradient = $$('paint0_linear')
const waveGradient = $$('paint1_linear')

const greenTank = $('green-tank')
const redTank = $('red-tank')
const purpleTank = $('purple-tank')


// ANIMATION UTILITY FUNCTIONS
function drawSVG(path, drawingDuration = 2, positionParameter = '', ease = 'power4.out') {
    const l = path.getTotalLength()
    const tl = new gsap.timeline()
    tl.set(path, {strokeDasharray:l})
    .fromTo(path, {
        strokeDashoffset:l,
        opacity: 0
    }, {
        strokeDashoffset:0,
        duration: drawingDuration,
        opacity: 1,
        ease: ease
    }, positionParameter);
    return tl
}

function curvedDrawingSVGAndStrokeAnimation(path, duration = 10, strokeDasharray= '4 4', reverse = false){
  const tl = new gsap.timeline()
  drawSVG(path, reverse)

  if(!reverse){
    tl.to(path, {
      strokeDasharray: strokeDasharray,
      strokeOpacity: 0.5,
      ease: 'power4.out',
      duration: 0.2
    }, 'dashes+=1')
  
    .fromTo(path, {
      strokeDashoffset: path.getTotalLength() , 
    }, {
      strokeDashoffset: 0,
      ease: 'linear',
      repeat: -1,
      duration: duration
    }, '>')  

  } else {
    tl.to(path, {
      strokeDasharray: strokeDasharray,
      strokeOpacity: 0.5,
      ease: 'power4.out',
      duration: 0.2
    }, 'dashes+=1')
  
    .fromTo(path, {
      strokeDashoffset: 0,
    }, {
      strokeDashoffset: path.getTotalLength() , 
      ease: 'linear',
      repeat: -1,
      duration: duration
    }, '>')  
  }
  
  return tl
}

function alphaAnimation(element, drawingDuration = 2, ease = 'sine', positionParameter = ''){
  const tl = new gsap.timeline()
  tl
    .fromTo(element, {
      opacity: 0
    }, {
      duration: drawingDuration,
      opacity: 1,
      ease: ease
    }, positionParameter);
  return tl
}

function removeElement(element) {
    if (typeof(element) === "string") {
        element = document.querySelector(element);
    }
    return function() {
        element.parentNode.removeChild(element);
    };
}


//ANIMATIONS
function setThings(){
  const tl = new gsap.timeline()
  tl.set([jetMixer, boPipeOuter, boPipeInner, addPipeOuter, addPipeInner, mixerOutletPipeOuter, mixerOutletPipeInner, reEntryPipeOuter, reEntryPipeInner, mixerCover, mixriteStaticMixer], {
    opacity: 0
  })
  .set([boPump, addPump], {opacity: 0})
  .set([boFlow, addFlow, staticMixerExitFlow, reEntryFlow],{
      opacity: 0
  })
  // .set([boFlow, addFlow, boPipeOuter, boPipeInner, addPipeOuter, addPipeInner, staticMixerExitFlow, reEntryFlow],{
  //     opacity: 0
  // })
  .set(mixingFlowLinesArray, {opacity: 0})
  .set([boGateValve, boGateValve2, boNRCValve, addGateValve, addGateValve2, reEntryValve, reEntryValve2], {
      opacity: 0,
  })
  .set(boNRCValve, {x: -10})
  .set(purpleTank, {attr: {y: 450}})
  .set([spiralR, spiralL, flowR, flowL, arrowR, arrowL], {opacity: 0})
  return tl
}
// function waterWaving(){
//   const tl = new gsap.timeline()
//   tl.fromTo(wavePattern, {
//     x: -1900
//   }, {
//     x: 0,
//     duration: 10,
//     repeat: -1
//   })
//   return tl
// }

function makeThemMove(){
    const tl = new gsap.timeline()
    .fromTo([greenTank, redTank, purpleTank], 
        {
            attr:{x: '-1900'}
        } ,
        {
            attr:{x: '0px'}, 
            duration: gsap.utils.wrap([35, 30, 45]), 
            repeat: -1,
            ease: 'linear'
        },'')
    return tl
}
function entryofTankAndFan() {
  const tl = new gsap.timeline
  tl.from([boResourceTank, addResourceTank], {
      opacity: 0,
      y: -3,
      ease: 'sine',
      duration: 0.5,
      stagger:  0.1
  }).from([baseOil, additive], {
      opacity: 0,
      x: 3,
      ease:  'sine',
      duration: 0.5,
      stagger: 0.3
  }, "")
  .addLabel('mixer-=1')
  //U1
  .from(finalResourceTank, {y: 3, ease: 'sine', opacity: 0, duration: 0.5}, '-=0.5')
  // .from(mixerCover, {x: 5, ease: 'sine', opacity: 0, duration: 1}, '-=1')
  // .from(mixriteStaticMixer, {y: -5, ease: 'sine', opacity: 0, duration: 1}, '-=1')
  return tl
}
function pipeCreations(){
  const tl = new gsap.timeline()
  drawSVG(boPipeOuter, 2, '')
  drawSVG(boPipeInner, 2, '')
  drawSVG(addPipeOuter, 2, '+=0.5')
  drawSVG(addPipeInner, 2, '+=0.5')
  drawSVG(mixerOutletPipeOuter, 2, '+2')
  drawSVG(mixerOutletPipeInner, 2, '+2')
  drawSVG(reEntryPipeOuter, 2, '+3')
  drawSVG(reEntryPipeInner, 2, '+3')
  // U1
  .to(jetMixer, {
    opacity: 1,
    duration: 1,
    ease: 'sine'
  }, '-=0.5')
  return tl
}
function pipeAppearance(){
  const tl = new gsap.timeline()
  alphaAnimation(boPipeOuter, 3, '')
  alphaAnimation(boPipeInner, 3, '')
  alphaAnimation(addPipeOuter, 3, '+=0.5')
  alphaAnimation(addPipeInner, 3, '+=0.5')
  alphaAnimation(mixerOutletPipeOuter, 3, '+3')
  alphaAnimation(mixerOutletPipeInner, 3, '+3')
  alphaAnimation(reEntryPipeOuter, 3, '+3')
  alphaAnimation(reEntryPipeInner, 3, '+3')
  alphaAnimation(boNRCValve, 3, '+3')
  // U1
  .addLabel('start')
  .to(jetMixer, {opacity: 1, duration: 2, ease: 'sine'}, '+0.8')
  .fromTo(mixerCover, {x: 3, ease: 'sine', opacity: 0, duration: 0.5}, {opacity: 1, x: 0 }, '+0.8')
  .fromTo(mixriteStaticMixer, {y: -5, ease: 'sine', opacity: 0, duration: 0.5}, {opacity: 1, y: 0}, '+0.8')
  return tl
}
function valvesAndPumpAppearance(){
  const tl = new gsap.timeline()
  alphaAnimation(reEntryValve2)
  alphaAnimation(reEntryValve)
  alphaAnimation(boGateValve)
  alphaAnimation(addGateValve)
  alphaAnimation(boGateValve2) 
  alphaAnimation(addGateValve2)
  alphaAnimation(boPump) 
  alphaAnimation(addPump)
  return tl
}
function flowStart(){
    const tl = new gsap.timeline()
    tl
    // .addLabel('valves')
    // .fromTo(reEntryValve2, {
    //     x: 5,
    //     opacity: 0,
    //     ease: 'sine',
    //     duration: 1
    // }, {
    //     opacity: 1,
    //     x: 0,
    // })
    // .fromTo([boGateValve, addGateValve], {
    //     y:5,
    //     opacity: 0,
    //     ease: 'sine',
    //     duration: 1,
    // }, {
    //     stagger: 0.5,
    //     opacity: 1,
    //     y: 0,
    // }, 'valves')
    // .fromTo([boGateValve2, addGateValve2], {
    //     y: -5,
    //     opacity: 0,
    //     ease: 'sine',
    //     duration: 1,
    // }, {
    //     stagger: 0.5,
    //     opacity: 1,
    //     y: 0,
    // },'valves')
    // .to(boNRCValve, {
    //     opacity: 1,
    //     x: 0,
    //     duration: 1,
    //     ease: 'sine',
    // }, 'values')
    // .fromTo([boPump, addPump], {
    //     y: -5,
    //     opacity: 0,
    // }, {
    //     opacity: 1,
    //     stagger: 0.4,
    //     duration: 1.5
    // })

    .addLabel('bo')
    .fromTo(boPump, {
        rotate: '0deg',
        transformOrigin: 'center center',
    },{
        repeat: -1,
        duration: 1.5,
        rotate: '360deg',
        ease: 'linear'
    })
    .addLabel('add')
    .fromTo(addPump, {
        rotate: '0deg',
        transformOrigin: 'center center',
    },{
        repeat: -1,
        duration: 1.5,
        rotate: '360deg',
        ease: 'linear'
    })
    
    .fromTo(boFlow, {
        strokeDasharray: "0 0",
        opacity: 0,
        duration: 0.5,
        attr: {d:  "M62 83"}
      }, {
        opacity: 1,
        attr: {d:  "M62 83v125"}
      }, 'bo+=0.5')
      .to(boFlow, {
        attr: {d: "M62 83v125h165"},
        strokeDasharray: '6.38 6.38',
        duration: 2
      }, '>')
      .fromTo(boFlow, {
        strokeDashoffset: boFlow.getTotalLength() , 
      }, {
        strokeDashoffset: 0,
        ease: 'linear',
        repeat: -1,
        duration: 4
      }, '>')

      .fromTo(addFlow, {
        strokeDasharray: "0 0",
        opacity: 0,
        duration: 0.5,
        attr: {d:  "M175 83"}
      }, {
        opacity: 1,
        attr: {d:  "M175 83v125"}
      }, 'add+=0.5')
      .to(addFlow, {
        attr: {d: "M175 83v125h55"},
        strokeDasharray: '6.38 6.38',
      }, '>')
      .fromTo(addFlow, {
        strokeDashoffset: addFlow.getTotalLength() , 
      }, {
        strokeDashoffset: 0,
        ease: 'linear',
        repeat: -1,
        duration: 4
      })


    return tl
}
function mixingLines(){
    const tl = new gsap.timeline()
    drawSVG(mixingFlowLinesArray[0], 4.1, '', 'power4.in')
    drawSVG(mixingFlowLinesArray[1], 4.2, '', 'power4.in')
    drawSVG(mixingFlowLinesArray[2], 4.3, '', 'power4.in')
    drawSVG(mixingFlowLinesArray[3], 4.4, '', 'power4.in')
    drawSVG(mixingFlowLinesArray[4], 4.3, '', 'power4.in')
    drawSVG(mixingFlowLinesArray[5], 4.2, '', 'power4.in')
    drawSVG(mixingFlowLinesArray[6], 4.1, '', 'power4.in')

    .set(mixingFlowLinesArray, {
        strokeDasharray: '2 2',
        // ease: 'power4.out',
        // duration: 0.1
      },)
      .fromTo(mixingFlowLinesArray, {
        strokeDashoffset: mixingFlowLinesArray[0].getTotalLength() , 
      }, {
        strokeDashoffset: 0,
        ease: 'linear',
        repeat: -1,
        duration: 10
      }, '>')
    return tl
}
function mixerExitFlow(){
    const tl = new gsap.timeline()
    tl.fromTo(staticMixerExitFlow, {
        strokeDasharray: "0 0",
        opacity: 0,
        duration: 0.5,
        attr: {d:  "M371.101 208"}
      }, {
        opacity: 1,
        attr: {d:  "M371.101 208h20.899"}
      })
      .to(staticMixerExitFlow, {
        attr: {d: 'M371.101 208h20.899v183'},
        strokeDasharray: '6.38 6.38',
    }, '>')
      .to(staticMixerExitFlow, {
        attr: {d: 'M371.101 208h20.899v183h-150'},
    }, '>')
      .to(staticMixerExitFlow, {
        attr: {d: "M371.101 208h20.899v183h-150l-10.947 -3.676"},
      }, '<')
      .fromTo(staticMixerExitFlow, {
        strokeDashoffset: staticMixerExitFlow.getTotalLength() , 
      }, {
        strokeDashoffset: 0,
        ease: 'linear',
        repeat: -1,
        duration: 4
      }, '-=1')
    return tl
}
function tankFlowLines(){
  const tl = new gsap.timeline()
  //Draw the two lines
  drawSVG(flowR, 3)
  drawSVG(flowL, 3)

  tl
  
  .to([spiralL, spiralR], {opacity: 1})
  drawSVG(spiralL, 2, 'sine.in', '0.5')
  drawSVG(spiralR, 2, 'sine.in', '0.5')
  .to([arrowR, arrowL], {
    opacity: 1,
  })
  .addLabel('dashes')
  .to([spiralL, spiralR], {
    strokeDasharray: '4 6',
    ease: 'power4.out',
    strokeOpacity: 0.5,
    duration: 0.1
  }, '>')
  .fromTo([spiralL, spiralR], {
    strokeDashoffset: spiralL.getTotalLength() , 
  }, {
    strokeDashoffset: 0,
    ease: 'linear',
    repeat: -1,
    duration: 30
  }, '>')

  .to(flowL, {
    strokeDasharray: '4 4',
    strokeOpacity: 0.5,
    ease: 'power4.out',
    duration: 0.2
  }, 'dashes')

  .fromTo(flowL, {
    strokeDashoffset: flowL.getTotalLength() , 
  }, {
    strokeDashoffset: 0,
    ease: 'linear',
    repeat: -1,
    duration: 10
  }, '>')

  .to(flowR, {
    strokeDasharray: '4 4',
    ease: 'power4.out',
    strokeOpacity: 0.5,
    duration: 0.2
  }, 'dashes')
  .fromTo(flowR, {
    strokeDashoffset: flowR.getTotalLength() , 
  }, {
    strokeDashoffset: 0,
    ease: 'linear',
    repeat: -1,
    duration: 10
  }, '>')
  return tl
}
function levels(){
    const tl = new gsap.timeline()
    tl.addLabel('green')
    .fromTo([greenTank, redTank], 
    {
        attr:{y: '0'}
    } ,
    {
        attr:{y: '85px'}, 
        duration: gsap.utils.wrap([28, 25]),
        ease: 'linear'
    },'')
    .fromTo(purpleTank, 
    {
        attr:{y: '450'}
    } ,
    {
        attr:{y: '255px'}, 
        duration: gsap.utils.wrap([25]),
        ease: 'linear'
    },'')
    .call(removeElement(greenTank))
    .call(removeElement(redTank))
    return tl
}
function part2Animation(){
    const tl = new gsap.timeline()
    tl
      //Closing up the add tank
        .addLabel('stopFlows')
        .to(addPump, {rotate: '360deg', overwrite: 'auto'})
        .to(addFlow, {attr:{d: 'M175 206v2h55'}})
        .to(addFlow, {attr:{d: 'M225 206v2h0'}, autoAlpha: 0})
        

        // .fromTo(reEntryValve, {y: 10, opacity: 0}, {y:5, opacity: 1, duration: 1}, 'stopFlows-=0.4')
        .fromTo(reEntryFlow, {
            strokeDasharray: "0 0",
            opacity: 0,
            duration: 0.5,
            attr: {d:  "M157 440"}
        }, {
            opacity: 1,
            attr: {d:  "M157 440v41"}
        })
        .to(reEntryFlow, {
            attr: {d: 'M157 440v41h-152'},
            strokeDasharray: '6.38 6.38',
        }, '>')
        .to(reEntryFlow, {
            attr: {d: 'M157 440v41h-152v-359'},
        }, '>')
        .to(reEntryFlow, {
            attr: {d: "M157 440v41h-152v-359h51.5"},
        }, '>')
        .fromTo(reEntryFlow, {
            strokeDashoffset: reEntryFlow.getTotalLength() , 
        }, {
            strokeDashoffset: 0,
            ease: 'linear',
            repeat: -1,
            duration: 10
        }, '-=1')


        .to(boFlow, {
            attr:{d: 'M62 122v86h168'}
        }, 'stopFlows+=3')
        .to(boFlow, {
            stroke: '#B189AE',
            duration: 2
        })

        .to(linearGradientLinesArray, {
            stopColor: '#B189AE',
            duration: 0.1,
            ease: 'power4.out'
        })
    return tl
}

const master = new gsap.timeline()
master.add(setThings)
    // .add(makeThemMove)
    // U1
    .add(entryofTankAndFan)
    // .add(pipeCreations, "+=3.5")
    .add(pipeAppearance)
    .add(valvesAndPumpAppearance)
    .add(flowStart, "+=3")
    .add(mixingLines)
    .add(mixerExitFlow, "+=4")
    .add(tankFlowLines, "+=2")
    .add(levels, '+=0')
    .add(part2Animation, "+=24")

// replayButton.addEventListener('click', () => {
//   master.kill()
//   master.invalidate().restart()
// })
